import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    errors: []
};

const eventCreationMessages = createSlice({
    name: 'eventCreationErrors',
    initialState,
    reducers: {
        addEventCreationError: (state, action) => {
            // state.errors.push(action.payload)
            // console.log('Current errors:', [...state.errors])
            // Check if error with the same id already exists
            const errorExists = state.errors.some((error) => error.id === action.payload.id);
            if (!errorExists) {
                state.errors.push(action.payload);
                console.log('Error added:', action.payload);
            }
            // else {
            //     console.log('Error already exists:', action.payload.id);
            // }
            // console.log('Current errors:', [...state.errors]);
        },
        resetEventCreationErrors: (state) => {
            state.errors = [];
            console.log('Reset event creation errors');
        }
    }
});

export const { addEventCreationError, resetEventCreationErrors } = eventCreationMessages.actions;

export default eventCreationMessages.reducer;

/**
 * Following fields currently used in the event creation error object to handle event creation errors:
 * 1. error: string - Error message to be displayed
 * 2. moduleName: string - Name of the module where the error occurred
 * 3. url: string - URL to navigate to when the error is clicked
 * 4. id: string - Unique identifier for the error (used to check if the error already exists) and make menu active
 */
